export default __webpack_public_path__ + "static/media/irishlife-logo.fa30edb4.png";